import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { useProducts } from '../../hooks/useProducts';

const HomePage = () => {
  const { products: allProducts } = useProducts();

  const services = allProducts.slice(0, 3).map((product, index) => ({
    id: product.id,
    title: product.name,
    description: product.description,
    image: product.image,
    link: `/servicos/${product.slug}`,
    featured: index === 0,
  }));

  const products = allProducts.map(product => ({
    id: product.id,
    name: product.name,
    image: product.image,
    link: `/servicos/${product.slug}`,
  }));

  const steps = [
    {
      number: 1,
      icon: 'ri-whatsapp-line',
      title: 'Entre em Contato',
      description: 'Fale conosco pelo WhatsApp e conte sua ideia',
    },
    {
      number: 2,
      icon: 'ri-palette-line',
      title: 'Criação do Design',
      description: 'Nossa equipe desenvolve o layout personalizado',
    },
    {
      number: 3,
      icon: 'ri-printer-line',
      title: 'Produção',
      description: 'Sublimação de alta qualidade dos seus produtos',
    },
    {
      number: 4,
      icon: 'ri-truck-line',
      title: 'Entrega',
      description: 'Receba seus produtos no prazo combinado',
    },
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Carlos Eduardo Silva',
      company: 'Tech Solutions Ltda',
      rating: 5,
      text: 'Excelente qualidade nos brindes corporativos! Fizemos 200 canecas personalizadas para nosso evento e todos os clientes adoraram. A equipe da JR Gráfica foi muito atenciosa e entregou no prazo.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20portrait%20smiling%20confident%20corporate%20executive%20on%20clean%20simple%20white%20background%20studio%20photography%20bright%20lighting&width=200&height=200&seq=test1&orientation=squarish',
    },
    {
      id: 2,
      name: 'Mariana Costa',
      company: 'Boutique Elegance',
      rating: 5,
      text: 'Trabalho impecável! As camisetas personalizadas para minha loja ficaram perfeitas. A impressão é de altíssima qualidade e não desbota. Super recomendo a JR Gráfica!',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20portrait%20smiling%20confident%20entrepreneur%20on%20clean%20simple%20white%20background%20studio%20photography%20bright%20lighting&width=200&height=200&seq=test2&orientation=squarish',
    },
    {
      id: 3,
      name: 'Roberto Almeida',
      company: 'Academia Fitness Pro',
      rating: 5,
      text: 'Fizemos squeezes e bonés personalizados para nossa academia. A qualidade superou nossas expectativas! Atendimento rápido e preço justo. Já viramos clientes fixos.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20fitness%20instructor%20portrait%20smiling%20athletic%20man%20on%20clean%20simple%20white%20background%20studio%20photography%20bright%20lighting&width=200&height=200&seq=test3&orientation=squarish',
    },
    {
      id: 4,
      name: 'Juliana Ferreira',
      company: 'Eventos & Festas JF',
      rating: 5,
      text: 'Sempre que preciso de brindes personalizados para eventos, recorro à JR Gráfica. Nunca me decepcionaram! Qualidade excepcional e entrega sempre pontual.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20event%20planner%20woman%20portrait%20smiling%20creative%20professional%20on%20clean%20simple%20white%20background%20studio%20photography%20bright%20lighting&width=200&height=200&seq=test4&orientation=squarish',
    },
    {
      id: 5,
      name: 'Fernando Santos',
      company: 'Construtora Horizonte',
      rating: 5,
      text: 'Precisávamos de uniformes personalizados para toda a equipe. A JR Gráfica entregou um trabalho perfeito, com ótimo acabamento e dentro do orçamento. Muito satisfeitos!',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20construction%20manager%20portrait%20smiling%20confident%20engineer%20on%20clean%20simple%20white%20background%20studio%20photography%20bright%20lighting&width=200&height=200&seq=test5&orientation=squarish',
    },
    {
      id: 6,
      name: 'Patrícia Oliveira',
      company: 'Café & Cia',
      rating: 5,
      text: 'As canecas personalizadas para meu café ficaram lindas! A sublimação é de excelente qualidade e resistente. Meus clientes sempre elogiam. Parabéns pelo trabalho!',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20cafe%20owner%20woman%20portrait%20smiling%20entrepreneur%20barista%20on%20clean%20simple%20white%20background%20studio%20photography%20bright%20lighting&width=200&height=200&seq=test6&orientation=squarish',
    },
  ];

  const portfolioImages = [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=corporate%20event%20with%20personalized%20custom%20branded%20mugs%20and%20promotional%20products%20on%20clean%20simple%20white%20background%20professional%20photography%20commercial%20style%20bright%20lighting%20business%20gifts%20sublimation%20printing&width=600&height=900&seq=port1&orientation=portrait',
      title: 'Evento Corporativo XYZ',
      category: 'Brindes Empresariais',
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=beautiful%20wedding%20personalized%20custom%20printed%20gifts%20mugs%20and%20favors%20on%20clean%20simple%20white%20background%20elegant%20photography%20commercial%20style%20bright%20lighting%20sublimation%20printing&width=800&height=600&seq=port2&orientation=landscape',
      title: 'Casamento Maria & João',
      category: 'Lembranças de Casamento',
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=professional%20company%20team%20uniforms%20personalized%20custom%20printed%20t-shirts%20on%20clean%20simple%20white%20background%20studio%20photography%20commercial%20style%20bright%20lighting%20corporate%20branding&width=600&height=900&seq=port3&orientation=portrait',
      title: 'Uniformes Empresa ABC',
      category: 'Uniformes Corporativos',
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=promotional%20marketing%20products%20personalized%20custom%20branded%20items%20caps%20bottles%20on%20clean%20simple%20white%20background%20professional%20photography%20commercial%20style%20bright%20lighting%20sublimation&width=700&height=700&seq=port4&orientation=squarish',
      title: 'Campanha Promocional',
      category: 'Material Promocional',
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=sports%20team%20personalized%20custom%20printed%20uniforms%20and%20accessories%20on%20clean%20simple%20white%20background%20professional%20photography%20commercial%20style%20bright%20lighting%20sublimation%20printing&width=700&height=700&seq=port5&orientation=squarish',
      title: 'Time Esportivo',
      category: 'Uniformes Esportivos',
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=birthday%20party%20personalized%20custom%20printed%20gifts%20and%20favors%20on%20clean%20simple%20white%20background%20colorful%20photography%20commercial%20style%20bright%20lighting%20sublimation%20printing&width=600&height=900&seq=port6&orientation=portrait',
      title: 'Festa de Aniversário',
      category: 'Presentes Personalizados',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative h-[90vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20professional%20sublimation%20printing%20workshop%20with%20colorful%20personalized%20custom%20products%20mugs%20t-shirts%20caps%20displayed%20on%20clean%20simple%20white%20background%20bright%20vibrant%20colors%20commercial%20photography%20creative%20workspace%20printing%20equipment&width=1920&height=1080&seq=hero1&orientation=landscape"
            alt="JR Gráfica e Sublimação"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-transparent"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-block mb-6 px-5 py-2 border-2 border-white/30 rounded-full">
            <span className="text-white text-sm font-poppins">Personalização Profissional desde 2020</span>
          </div>

          <h1 className="font-montserrat font-extrabold text-5xl md:text-7xl text-white leading-tight mb-8">
            Transformamos Suas Ideias em<br />
            <span className="text-accent-yellow">Produtos Únicos</span>
          </h1>

          <p className="text-white/90 text-xl md:text-2xl font-poppins font-light mb-12 max-w-3xl mx-auto">
            Sublimação de alta qualidade para empresas, eventos e presentes personalizados
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
            <Link
              to="/servicos"
              className="flex items-center gap-3 bg-accent-red text-white px-8 py-4 rounded-full font-poppins font-medium hover:bg-red-600 transition-all whitespace-nowrap cursor-pointer shadow-xl"
            >
              Ver Nossos Produtos
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
            <a
              href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20da%20JR%20Gráfica%20e%20Sublimação."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-poppins font-medium hover:bg-white hover:text-primary transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-accent-red font-poppins font-medium text-sm">/serviços</span>
            <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-primary mt-4 mb-6">
              O Que Fazemos de Melhor
            </h2>
            <div className="w-20 h-1 bg-accent-yellow mx-auto"></div>
          </div>

          {services.length > 0 && (
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
              {/* Featured Service */}
              <div className="lg:col-span-5">
                <Link to={services[0].link} className="block group cursor-pointer">
                  <div className="relative h-[500px] bg-primary rounded-3xl overflow-hidden">
                    <img
                      src={services[0].image}
                      alt={services[0].title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-8">
                      <h3 className="font-montserrat font-bold text-3xl text-white mb-3">
                        {services[0].title}
                      </h3>
                      <p className="text-white/90 text-base font-poppins">
                        {services[0].description}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Other Services */}
              <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-8">
                {services.slice(1).map((service) => (
                  <Link
                    key={service.id}
                    to={service.link}
                    className="block group cursor-pointer"
                  >
                    <div className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                      <div className="relative h-64">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="p-6">
                        <h3 className="font-montserrat font-bold text-2xl text-primary mb-2">
                          {service.title}
                        </h3>
                        <p className="text-gray-600 text-sm font-poppins mb-4">
                          {service.description}
                        </p>
                        <button className="w-full py-3 border-2 border-accent-red text-accent-red rounded-xl font-poppins font-medium hover:bg-accent-red hover:text-white transition-all whitespace-nowrap">
                          Ver Detalhes
                        </button>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Products Section */}
      <section className="py-24 bg-white" data-product-shop>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-start justify-between mb-16 gap-8">
            <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-primary lg:w-2/5">
              Catálogo Completo de Produtos
            </h2>
            <p className="text-gray-700 text-lg font-poppins leading-relaxed lg:w-2/5">
              Explore nossa linha completa de produtos para personalização. Cada item pode ser customizado com sua marca, arte ou mensagem especial.
            </p>
          </div>

          {products.length > 0 && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {products.map((product) => (
                <Link
                  key={product.id}
                  to={product.link}
                  className="group cursor-pointer"
                >
                  <div className="relative bg-gradient-to-b from-white to-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                    <div className="aspect-[3/4] overflow-hidden">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-4 text-center">
                      <h3 className="font-poppins font-semibold text-lg text-primary mb-1">
                        {product.name}
                      </h3>
                    </div>
                    <a
                      href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20da%20JR%20Gráfica%20e%20Sublimação."
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="absolute bottom-4 right-4 w-12 h-12 flex items-center justify-center bg-accent-yellow rounded-full hover:scale-110 transition-transform cursor-pointer shadow-lg"
                    >
                      <i className="ri-whatsapp-line text-primary text-xl"></i>
                    </a>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-accent-red font-poppins font-medium text-sm">/depoimentos</span>
            <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-primary mt-4 mb-6">
              O Que Nossos Clientes Dizem
            </h2>
            <div className="w-20 h-1 bg-accent-yellow mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="flex items-center gap-4 mb-6">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h3 className="font-poppins font-semibold text-lg text-primary">
                      {testimonial.name}
                    </h3>
                    <p className="text-gray-600 text-sm font-poppins">
                      {testimonial.company}
                    </p>
                  </div>
                </div>

                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, index) => (
                    <i key={index} className="ri-star-fill text-accent-yellow text-lg"></i>
                  ))}
                </div>

                <p className="text-gray-700 font-poppins text-sm leading-relaxed">
                  "{testimonial.text}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-24 bg-gray-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: `radial-gradient(circle, #E5E7EB 1px, transparent 1px)`,
          backgroundSize: '30px 30px',
        }}></div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-primary mb-4">
              Processo Simples em 4 Passos
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {steps.map((step, index) => (
              <div key={step.number} className="relative text-center">
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-1/2 w-full h-0.5 border-t-2 border-dashed border-accent-yellow"></div>
                )}
                <div className="relative z-10 flex flex-col items-center">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-accent-red to-accent-yellow flex items-center justify-center mb-6 shadow-lg">
                    <span className="font-montserrat font-bold text-3xl text-white">{step.number}</span>
                  </div>
                  <div className="w-16 h-16 flex items-center justify-center mb-4">
                    <i className={`${step.icon} text-4xl text-primary`}></i>
                  </div>
                  <h3 className="font-poppins font-semibold text-xl text-primary mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm font-poppins max-w-[200px]">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20da%20JR%20Gráfica%20e%20Sublimação."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-accent-red text-white px-10 py-5 rounded-full font-poppins font-medium hover:bg-red-600 transition-all whitespace-nowrap cursor-pointer shadow-xl text-lg"
            >
              Iniciar Meu Pedido Agora
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="py-24 bg-primary relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-16">
            <span className="text-white/70 font-poppins text-sm">(trabalhos realizados)</span>
            <h2 className="font-montserrat font-bold text-5xl md:text-6xl text-white mt-4 mb-2">
              Projetos Que Nos
            </h2>
            <h2 className="font-montserrat font-bold text-5xl md:text-6xl text-accent-yellow">
              Orgulham
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {portfolioImages.map((item) => (
              <div
                key={item.id}
                className="group relative overflow-hidden rounded-3xl cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center px-6">
                    <i className="ri-add-line text-white text-5xl mb-4"></i>
                    <h3 className="font-montserrat font-bold text-2xl text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-white/90 text-base font-poppins">
                      {item.category}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative h-[75vh] flex items-end overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20professional%20sublimation%20printing%20machine%20in%20action%20with%20colorful%20vibrant%20personalized%20products%20being%20produced%20on%20clean%20simple%20white%20background%20bright%20colors%20commercial%20photography%20creative%20production%20workspace&width=1920&height=1080&seq=cta1&orientation=landscape"
          alt="Produção JR Gráfica"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-primary/50 to-primary/70"></div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pb-24">
          <div className="flex flex-col lg:flex-row items-end justify-between gap-12">
            <h2 className="font-montserrat font-bold text-5xl md:text-7xl text-white lowercase">
              pronto para<br />personalizar?
            </h2>

            <div className="text-right">
              <p className="text-white/95 text-xl md:text-2xl font-poppins font-light leading-relaxed mb-8">
                Solicite seu orçamento sem compromisso<br />
                Resposta em até 2 horas
              </p>
            </div>
          </div>

          <div className="mt-12">
            <a
              href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20da%20JR%20Gráfica%20e%20Sublimação."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-6 bg-white px-8 py-5 rounded-full hover:shadow-2xl transition-all cursor-pointer group"
            >
              <span className="text-primary font-poppins font-semibold text-lg whitespace-nowrap">
                Falar com Especialista
              </span>
              <div className="w-14 h-14 flex items-center justify-center bg-accent-red rounded-full group-hover:scale-110 transition-transform">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;